module.exports = "mat-form-field {\n  width: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./Angular/app/home/add-pmo/add-pmo.component.less
// module id = ./Angular/app/home/add-pmo/add-pmo.component.less
// module chunks = main